import { render, staticRenderFns } from "./TabReservationsEdit.vue?vue&type=template&id=4bdfb7dd&"
import script from "./TabReservationsEdit.vue?vue&type=script&lang=ts&"
export * from "./TabReservationsEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4bdfb7dd', component.options)
    } else {
      api.reload('4bdfb7dd', component.options)
    }
    module.hot.accept("./TabReservationsEdit.vue?vue&type=template&id=4bdfb7dd&", function () {
      api.rerender('4bdfb7dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/TabsModals/Reservations/TabReservationsEdit.vue"
export default component.exports